import { useState, useRef, useEffect } from 'react';
export const useTimer = () => {
    const [remainingTime, setRemainingTime] = useState(null);
    const timerId = useRef();
    const clear = () => {
        if (timerId.current) {
            window.clearInterval(timerId.current);
        }
    };
    useEffect(() => {
        return () => clear();
    }, []);
    useEffect(() => {
        if (remainingTime === 0) {
            clear();
        }
    }, [remainingTime]);
    const stopTimer = () => {
        clear();
        setRemainingTime(0);
    };
    const tick = () => {
        setRemainingTime((prevTime) => prevTime && prevTime - 1);
    };
    const startTimer = (time) => {
        clear();
        timerId.current = window.setInterval(tick, 1000);
        setRemainingTime(time);
    };
    return {
        remainingTime,
        stopTimer,
        startTimer
    };
};
